module.exports = __webpack_public_path__ + "img/fd-background-image.3fd6a40.png";